import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Transition from '@material-ui/core/Fade';
import PropTypes from 'prop-types';
import TextBox from '@trdk/style/TextBox';
import logo from '../images/logo.svg';

const ErrorPage = ({ title, text }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Transition in timeout={800}>
          <Grid container spacing={2}>
            <Grid item xs={12} className={classes.centercontent}>
              <img src={logo} className={classes.logo} alt="Trondheim kommune logo" />
              <Typography variant="h6">Trondheim kommune</Typography>
              <Typography variant="h1" color="primary" className={classes.title}>
                Filopplasting Modulus Barn
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextBox title={title}>{text}</TextBox>
            </Grid>
          </Grid>
        </Transition>
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

const useStyles = makeStyles({
  container: {
    height: '100%',
    width: '100%',
    zIndex: 10,
    minHeight: '100vh',
    paddingBottom: '5rem',
    display: 'flex',
    justifyContent: 'center',
  },
  logo: {
    height: '10rem',
    marginBottom: '-1.5rem',
    marginTop: '-1.5rem',
  },
  centercontent: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: '1rem',
  },
  title: {
    margin: '1rem 0',
    fontSize: '3rem',
  },
  content: {
    maxWidth: '42rem',
    margin: '1rem',
  },
});

export default ErrorPage;
